import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { CartIcon, CartIconWhite } from '../../ui-library/icons';
import { Badge } from '../../ui-library/molecules/notifications';
import useCart from '../store/cart/useCart';
import { trackHeaderShoppingCartButtonClick } from '../tracking/header.tracking';
import { hideSidebar } from '../ui/ui.actions';
import useNavigation from '../../utils/useNavigation';

const StyledWrapper = styled.div`
  cursor: pointer;
  position: relative;
  margin-right: ${(props) => (props.countOfItems > 0 ? '16px' : '0')};
`;
const StyledCartImage = styled.div`
  margin-left: 32px;
  margin-top: 7px;
  width: 32px;
`;
const StyledBadgeWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 50px;
`;
const CartLink = ({ isDark }) => {
  const dispatch = useDispatch();
  const { countOfItems } = useCart();
  const { goToCart } = useNavigation();

  const handleClick = () => {
    dispatch(hideSidebar());
    goToCart();
    trackHeaderShoppingCartButtonClick();
  };
  return (
    <StyledWrapper onClick={handleClick} countOfItems={countOfItems}>
      <StyledCartImage>
        {isDark ? <CartIcon /> : <CartIconWhite />}
      </StyledCartImage>
      <StyledBadgeWrapper>
        <Badge count={countOfItems} />
      </StyledBadgeWrapper>
    </StyledWrapper>
  );
};

export default CartLink;
